<template>
	<button @click="handleClick">
		<slot />
	</button>
</template>

<script>
export default {
	methods: {
		handleClick() {
			window.scrollTo( {
				top: 0,
				left: 0,
				behavior: 'smooth',
			} );
		},
	},
};
</script>
